module.exports = __webpack_public_path__ + "img/ug.6368fa8f.svg";